import { Box, Typography } from "@mui/material";
import LockIcon from "@mui/icons-material/LockOutlined";
import { ArtButton } from "@art/shared-ui";
import { useNavigate } from "react-router-dom";
import styles from "./access-denied.module.scss";
import { usePageWrapper } from "../../hooks/page-wrapper.hook";

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <Box className={styles.container_wrapper}>
      <Box className={styles.icon_wrapper}>
        <LockIcon sx={{ fontSize: 44, color: "var(--error-color)" }} />
      </Box>
      <Typography variant="h4" className={styles.title}>
        Access Denied
      </Typography>
      <Typography variant="body1" className={styles.description}>
        You do not have the required permissions to view this resource.
        Please contact your administrator to request access.
      </Typography>
      <Box className={styles.btn_wrapper}>
        <ArtButton label="Go Back" onClick={() => navigate(-1)} />
      </Box>
    </Box>
  );
};

export default usePageWrapper(AccessDenied, { page_title: "Access Denied" });
